import { PayloadAction } from '@reduxjs/toolkit';
import { configRequest } from 'core/services/product';
import { all, call, fork, put, take } from 'redux-saga/effects';
import { IDomain } from 'types/domain/organisation';

function* init() {
  const domain = window.location.host.split('.')[0];

  yield put(yield call(configRequest, domain));
  const action: PayloadAction<IDomain> = yield take([configRequest.fulfilled]);
  const { domainConfig } = action.payload;
  if (domainConfig != null) {
    //document.documentElement.style.setProperty('--link-color', theme.background);
    document.documentElement.style.setProperty('--brand', domainConfig.primaryBtn);
    //document.documentElement.style.setProperty('--module-bg', 'linear-gradient(180deg, rgba(30,41,59,1) 35%, rgba(41,64,102,1) 100%)');
    if (domainConfig?.dialogBg) document.documentElement.style.setProperty('--module-bg', domainConfig.dialogBg);
    if (domainConfig?.dialogText) document.documentElement.style.setProperty('--module-txt', domainConfig.dialogText);

    if (domainConfig?.dark === true) {
   
     // document.documentElement.classList.add('dark');
    }

    //if (domainConfig?.dialogText) document.documentElement.style.setProperty('--module-txt', domainConfig.dialogText);

    //theme.
  }
  //
}

export default function* configSaga() {
  yield all([fork(init)]);
}
